import { StoryblokComponent } from "@storyblok/react";
import { renderRichText } from "@/lib/richText";
import React from "react";
import Link from "next/link";
import { logger } from '@/lib/logger';

const EXCLUDED_BLOCKS = ["hero"];

const PageBulletproof = ({ content, trustSmall }: { content: any; trustSmall?: any[] | null }) => {

  const { body } = content;

  const blog_content = body?.filter((item: any) => item.component === "blog_content");

  return (
    <>
      {Array.isArray(content.body) &&
        content.body
          .filter((blok: any) => !EXCLUDED_BLOCKS.includes(blok.component))
          .map((blok: any) => {
            if (blok.component === "hero_animated") {
              return (
                <StoryblokComponent
                  blok={blok}
                  trustSmall={trustSmall}
                  key={blok._uid}
                />
              );
            }

            if (blok.component === "blog_details") {
              return (
                <StoryblokComponent
                  blok={blok}
                  blog_content={blog_content || []}
                  blog_author={null}
                  key={blok._uid}
                />
              );
            }

            if (blok.component === "related_resources") {
              if (!Array.isArray(blok.select_story) || blok.select_story.length === 0) {
                return null;
              }

              const blogItems = blok.select_story
                .filter((story: any) => {
                  const isValid = story && story.content && typeof story.content === "object";
                  if (!isValid) {
                    logger.log("Invalid story content:", story?.uuid || story?._uid);
                  }
                  return isValid;
                })
                .map((story: any) => {
                  const content = story.content;
                  const metatags = content.metatags || {};
                  const blogDetail = Array.isArray(content.blog_details) && content.blog_details.length > 0
                    ? content.blog_details[0]
                    : null;
                  const blogAuthor = Array.isArray(content.blog_author) ? content.blog_author[0] : {};
                  const blogPost = Array.isArray(content.hero_blog_post) ? content.hero_blog_post[0] : {};

                  const transformSlug = (fullSlug: string) => {
                    const segments = fullSlug.split('/');
                    return segments.length > 2 ? `/${segments.slice(2).join('/')}` : fullSlug;
                  };

                  return {
                    _uid: story.uuid || `featured-${Math.random()}`,
                    component: "related_resources",
                    title: story.name || "",
                    thumb: blogPost?.image?.filename || metatags.og_image || "",
                    topics: blogDetail?.topics || [],
                    slug: transformSlug(story.full_slug || ""),
                    author_name: blogAuthor?.name || "",
                    author_photo: blogAuthor?.content?.image?.filename || "",
                  };
                });

              if (blogItems.length === 0) {
                return null;
              }

              const backgroundClass = blok.bg_style === "dark" ? "bg-light" : "";

              return (
                <div key={blok._uid} className={`${backgroundClass}`}>
                  <section className={`container py-4 py-md-5`}>
                    <h2 className="no-toc text-primary text-center mb-4">
                      {blok.headline || "Related resources"}
                    </h2>
                    {blok.subtitle && (
                      <div
                        className="lead text-center mb-5"
                        dangerouslySetInnerHTML={{ __html: renderRichText(blok.subtitle) }}
                      />
                    )}
                    <div
                      className="row g-4 justify-content-center row-cols-1 row-cols-md-2 row-cols-xl-4 gy-3 gx-md-3 gy-xl-0 gx-xl-4">
                      {blogItems.map((blogItem: any) => (
                        <StoryblokComponent
                          blok={blogItem}
                          key={blogItem._uid}
                        />
                      ))}
                    </div>
                    {blok.cta_button && blok.cta_button_link?.url && (
                      <p className="text-center mt-5 mb-0">
                        <Link
                          href={blok.cta_button_link.url}
                          className="btn btn-primary btn-lg"
                        >
                          {blok.cta_button}
                        </Link>
                      </p>
                    )}
                  </section>
                </div>
              );
            }

            if (
              blok.component === "reference_selector" &&
              blok.select_story?.length
            ) {
              const resolvedStory = blok.select_story[0]?.content;
              return resolvedStory ? (
                <StoryblokComponent blok={resolvedStory} key={blok._uid} />
              ) : (
                <div key={blok._uid}>Error: select_story not resolved</div>
              );
            }

            return <StoryblokComponent blok={blok} key={blok._uid} />;
          })}
    </>
  );
};

export default PageBulletproof;